export const WizardTypeMap = {
    FIRST_FILL: 'first_fill',
    REFILL: 'refill',
};
export const CheckoutFlowEndpoint = (makeRequest) => {
    return {
        fetchEnterCheckout(params, options) {
            return makeRequest('GET', '/checkout_flow/enter_checkout', params, options);
        },
        fetchEnterCart(params, options) {
            return makeRequest('GET', '/checkout_flow/enter_cart', params, options);
        },
        fetchAddToCart(params, options) {
            return makeRequest('GET', '/checkout_flow/add_to_cart', params, options);
        },
    };
};
//# sourceMappingURL=checkout_flow_endpoint.js.map